import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import DateObject from 'react-date-object';

export default class AuditLogs extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'auditlog',
            data: null,
            loading: true,
            page: 1,
            per_page: 20,
            phrase: '',
            filters: {
                userId: null,
                actionType: null,
                fromDate: null,   
                toDate: null
            },
            expandedRowId: null   
        };
    }

    componentDidMount() { this.refreshData(); }

    toShamsiString(dateObj) {
        if (!dateObj) return null;
        return dateObj.format('YYYY/MM/DD');
    }

    refreshData(e) {
        if (e) e.preventDefault();
        this.setState({ loading: true });
        this.httpPost(`api/v1/${this.state.controllerName}/list`, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: {
                ...this.state.filters,
                fromDate: this.toShamsiString(this.state.filters.fromDate),
                toDate: this.toShamsiString(this.state.filters.toDate)
            }
        }).then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({ data: data, loading: false });
            } else if (data.status === -5) window.location.href = "/access-denied";
            else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    }

    toggleRow = (id) => {
        this.setState(prev => ({
            expandedRowId: prev.expandedRowId === id ? null : id
        }));
    };

    parseValues(jsonStr) {
        if (!jsonStr) return null;
        try {
            const obj = JSON.parse(jsonStr);
            return Object.keys(obj).map(key => ({
                key,
                value: obj[key] !== null && obj[key] !== undefined ? obj[key].toString() : '---'
            }));
        } catch {
            return null;
        }
    }

    renderForm() {
        const { data, phrase, filters, expandedRowId } = this.state;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گزارش فعالیت‌ها (Audit Log)</h3>
                        </div>
                    </div>
                </div>

                <div className="card card-bordered mb-3">
                    <div className="card-inner">
                        <form onSubmit={e => this.refreshData(e)}>
                            <div className="row g-3">
                                <div className="col-md-2">
                                    <input type="text" className="form-control" placeholder="جستجو"
                                        value={phrase}
                                        onChange={e => this.setState({ phrase: e.target.value })} />
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select" value={filters.actionType || ''}
                                        onChange={e => this.setState({ filters: { ...filters, actionType: e.target.value || null } })}>
                                        <option value="">همه نوع‌ها</option>
                                        <option value="Create">ایجاد</option>
                                        <option value="Update">ویرایش</option>
                                        <option value="Delete">حذف</option>
                                        <option value="Login">ورود</option>
                                        <option value="Logout">خروج</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        value={filters.fromDate}
                                        onChange={date => this.setState({ filters: { ...filters, fromDate: date } })}
                                        format="YYYY/MM/DD"
                                        inputClass="form-control"
                                        placeholder="از تاریخ"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        value={filters.toDate}
                                        onChange={date => this.setState({ filters: { ...filters, toDate: date } })}
                                        format="YYYY/MM/DD"
                                        inputClass="form-control"
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <button type="submit" className="btn btn-primary">اعمال فیلتر</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {data?.recordsCount === 0 ? (
                            <div className="card-inner"><div className="example-alert"><div className="alert alert-info">هیچ رکوردی یافت نشد.</div></div></div>
                        ) : (
                            <div className="card-inner p-0">
                                <table className="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th>کاربر</th>
                                            <th>عملیات</th>
                                            <th>موجودیت</th>
                                            <th>شناسه</th>
                                            <th>توضیح</th>
                                            <th>IP</th>
                                            <th>تاریخ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.records?.map(l => (
                                            <React.Fragment key={l.id}>
                                                <tr onClick={() => this.toggleRow(l.id)} style={{ cursor: 'pointer' }}>
                                                    <td>{l.userName}</td>
                                                    <td>{l.actionType}</td>
                                                    <td>{l.entityName}</td>
                                                    <td>{l.entityId}</td>
                                                    <td>{l.description}</td>
                                                    <td>{l.ipAddress}</td>
                                                    <td>{l.createdDatePersian}</td>
                                                </tr>
                                                {expandedRowId === l.id && (
                                                    <tr>
                                                        <td colSpan="7">
                                                            <div className="p-3" style={{
                                                                background: 'rgba(42, 42, 42, 0.6)',
                                                                borderRadius: '12px',
                                                                border: '1px solid rgba(254, 194, 20, 0.15)'
                                                            }}>
                                                                <h6 style={{ color: '#FEC214', marginBottom: '1rem' }}>جزئیات تغییرات</h6>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <strong style={{ color: '#F8D25F' }}>مقادیر قدیم</strong>
                                                                        {l.oldValues ? (
                                                                            <table className="table table-sm table-bordered mt-2">
                                                                                <tbody>
                                                                                    {this.parseValues(l.oldValues)?.map(item => (
                                                                                        <tr key={item.key}>
                                                                                            <td style={{ color: '#9D9D9D' }}>{item.key}</td>
                                                                                            <td style={{ color: '#FFFFFF' }}>{item.value}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        ) : <p style={{ color: '#9D9D9D' }}>ندارد</p>}
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <strong style={{ color: '#F8D25F' }}>مقادیر جدید</strong>
                                                                        {l.newValues ? (
                                                                            <table className="table table-sm table-bordered mt-2">
                                                                                <tbody>
                                                                                    {this.parseValues(l.newValues)?.map(item => (
                                                                                        <tr key={item.key}>
                                                                                            <td style={{ color: '#9D9D9D' }}>{item.key}</td>
                                                                                            <td style={{ color: '#FFFFFF' }}>{item.value}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        ) : <p style={{ color: '#9D9D9D' }}>ندارد</p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                                {this.createPaging()}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}